module.exports = __webpack_public_path__ + "img/mlh.687e33f7.jpg";